import { render, staticRenderFns } from "./HierarchyOwner.vue?vue&type=template&id=c5d08e90&"
import script from "./HierarchyOwner.vue?vue&type=script&lang=ts&"
export * from "./HierarchyOwner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports